import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const emailAddress = "customercare@metro-sacco.co.ke";

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-white body-font">
      <div className="container px-5 py-8 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
        {/* Logo Section */}
        <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left mb-8 md:mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/assets/log.png`}
            className="h-18 w-auto"
            alt="Metro Sacco Logo"
          />
          <p className="mt-4 text-sm text-gray-300 font-semibold">
            "Building wealth, changing lives."
          </p>
        </div>

        {/* Footer Sections: Navigation, Useful Links, Address */}
        <div className="flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center w-full md:w-3/4">
          {/* Navigate Here Section */}
          <div className="lg:w-1/3 md:w-1/2 w-full px-4 mb-10">
            <h2 className="title-font font-semibold text-lg text-white tracking-widest mb-4">
              Navigate Here
            </h2>
            <nav className="list-none mb-6">
              <li>
                <button
                  onClick={() => scrollToSection("about-us")}
                  className="text-gray-300 hover:text-white"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="text-gray-300 hover:text-white"
                >
                  Contact Us
                </button>
              </li>
            </nav>
          </div>

          {/* Useful Links Section */}
          <div className="lg:w-1/3 md:w-1/2 w-full px-4 mb-10">
            <h2 className="title-font font-semibold text-lg text-white tracking-widest mb-4">
              Useful Links
            </h2>
            <nav className="list-none mb-6">
              <li>
                <button
                  onClick={() => scrollToSection("services")}
                  className="text-gray-300 hover:text-white"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("products")}
                  className="text-gray-300 hover:text-white"
                >
                  Products
                </button>
              </li>
            </nav>
          </div>

          {/* Address and Social Media Section */}
          <div className="lg:w-1/3 md:w-1/2 w-full px-4 mb-10">
            <h2 className="title-font font-semibold text-lg text-white tracking-widest mb-4">
              Our Location
            </h2>
            <p className="text-gray-300 mb-4 flex items-center">
              <FaMapMarkerAlt className="mr-2 text-teal-400" />
              Metropolitan Hospital, Nairobi, Buruburu.
            </p>
            <p className="text-gray-300 mb-4 flex items-center">
              <FaPhoneAlt className="mr-2 text-teal-400" />
              <a href="tel:+254711364094" className="hover:underline">
                0705767492/0785278786
              </a>
            </p>
            <p className="text-gray-300 mb-6 flex items-center">
              <FaEnvelope className="mr-2 text-teal-400" />
              <a href={`mailto:${emailAddress}`} className="hover:underline">
                {emailAddress}
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="bg-gray-800">
        <div className="container mx-auto py-2 px-5 flex flex-wrap flex-col sm:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm text-center sm:text-left">
            © Metropolitan Sacco Ltd —
            <a
              href={`mailto:${emailAddress}`}
              rel="noopener noreferrer"
              className="text-gray-400 ml-1"
              target="_blank"
            >
              Email: {emailAddress}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
